import { Box } from "@mui/material";
import { memo, useEffect, useMemo, useState } from "react";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useEventManagerContext } from "../../context/eventContext";

import JobHeader from "./JobHeader";
import JobSlots from "./JobSlots";
import JobActions from "./JobActions";

function JobCard({ job, angebote, onReserve, viewMode, onEdit, onDelete }) {
  const { currentUser, isTeacherView, isMobile } = useAppContext();
  const { isAnEventManagerAdmin } = useEventManagerContext();

  const [expanded, setExpanded] = useState(false);

  /**
   * =========================================================
   * ✅ DERIVED DATA
   * =========================================================
   */
  const { leitungSlots, teamSlots, filledSlots, totalSlots } = useMemo(() => {
    const leitung = [];
    const team = [];
    let filled = 0;

    angebote.forEach((a) => {
      if (a.type === "leitung") {
        leitung.push(a);
      } else {
        team.push(a);
      }
      if (a.reservedBy) filled++;
    });

    return {
      leitungSlots: leitung,
      teamSlots: team,
      filledSlots: filled,
      totalSlots: angebote.length,
    };
  }, [angebote]);

  const hasMyReservation = useMemo(() => {
    return angebote.some((a) => a.reservedBy?.id === currentUser?.id);
  }, [angebote, currentUser?.id]);

  const hasOpenLeitung = angebote?.some(
    (a) => a.type === "leitung" && !a.reservedBy,
  );

  const hasOpenStudent = angebote?.some(
    (a) => a.type === "team" && !a.reservedBy,
  );

  useEffect(() => {
    if (viewMode === "mine") {
      setExpanded(hasMyReservation);
    }

    if (viewMode === "leitung") {
      setExpanded(hasOpenLeitung);
    }

    if (viewMode === "student") {
      setExpanded(hasOpenStudent);
    }
  }, [viewMode, hasMyReservation, hasOpenLeitung, hasOpenStudent]);

  return (
    <Box sx={{ mt: 2, p: 1.5 }}>
      {/* ✅ HEADER */}
      <JobHeader
        job={job}
        filledSlots={filledSlots}
        totalSlots={totalSlots}
        progressColor="primary"
        onToggle={() => setExpanded((p) => !p)}
      />

      {/* ✅ CONTENT */}
      {expanded && (
        <>
          <JobSlots
            leitungSlots={leitungSlots}
            teamSlots={teamSlots}
            onReserve={onReserve}
          />

          <JobActions
            job={job}
            isMobile={isMobile}
            isAdmin={isAnEventManagerAdmin && !isTeacherView}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </>
      )}
    </Box>
  );
}

export default memo(JobCard);
